import { getAccessToken } from './authStorage';
import { getPortalApiBaseUrl } from './config';
import { AVATAR_MAX_EDGE_PX, BACKGROUND_MAX_EDGE_PX } from './constants';
import logger from './logger';
/** 与门户 JWT 过滤器 query 名一致 */
const ACCESS_TOKEN_QUERY = 'access_token';
/**
 * 拼接头像/背景图 URL（img src 无法带 Authorization，走 query token）。
 */
export function userMediaUrl(kind, user) {
    const token = getAccessToken();
    if (!token) {
        return null;
    }
    if (kind === 'avatar' && !user.hasAvatar) {
        return null;
    }
    if (kind === 'background' && !user.hasBackground) {
        return null;
    }
    const params = new URLSearchParams();
    params.set(ACCESS_TOKEN_QUERY, token);
    if (user.updatedAt) {
        params.set('v', user.updatedAt);
    }
    return `${getPortalApiBaseUrl()}/api/me/${kind}?${params.toString()}`;
}
/**
 * 压缩图片为 JPEG，控制边长与体积，便于手机 Web 上传。
 */
export function compressImageFile(file, kind) {
    const maxEdge = kind === 'avatar' ? AVATAR_MAX_EDGE_PX : BACKGROUND_MAX_EDGE_PX;
    return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file);
        const image = new Image();
        image.onload = () => {
            URL.revokeObjectURL(url);
            const scale = Math.min(1, maxEdge / Math.max(image.width, image.height));
            const width = Math.max(1, Math.round(image.width * scale));
            const height = Math.max(1, Math.round(image.height * scale));
            const canvas = document.createElement('canvas');
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext('2d');
            if (!ctx) {
                reject(new Error('无法压缩图片'));
                return;
            }
            ctx.drawImage(image, 0, 0, width, height);
            canvas.toBlob(blob => {
                if (!blob) {
                    reject(new Error('无法压缩图片'));
                    return;
                }
                logger.info(`[我的资料] ${new Date().toISOString()} 图片已压缩`
                    + ` | kind=${kind} from=${file.size} to=${blob.size} ${width}x${height}`);
                resolve(blob);
            }, 'image/jpeg', 0.85);
        };
        image.onerror = () => {
            URL.revokeObjectURL(url);
            logger.warn(`[我的资料] ${new Date().toISOString()} 读取本地图片失败 | name=${file.name}`);
            reject(new Error('无法读取图片'));
        };
        image.src = url;
    });
}
